<script lang="ts">
  import PaginationSmall from "@shared/svelte/Components/Pagination/Small.svelte";

  import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

  import type { PaginationDetails } from "@shared/types/Pagination";

  import moment from "moment";
  import { get } from "lodash";
  import { onMount } from "svelte";
  import { goto, params } from "@roxi/routify";

  let loading: boolean = true;
  let pagination: PaginationDetails;
  let referralLeads;

  const fetchReferralLeads = async (page = null) => {
    const pageParam = parseInt(page || $params.page || 1);
    try {
      const res = await HttpPromiseWithEntireResponse({
        url: "/api/distributor/referral_leads",
        method: "GET",
        data: {
          page: pageParam,
        },
      });

      referralLeads = await res.json();
      const perPage = Number(res.headers.get("X-Pagination-Limit"));
      const totalEntries = Number(res.headers.get("X-Pagination-Entries"));

      pagination = {
        goToPage: page => {
          fetchReferralLeads(page);
          $goto("/distributor/retailer_onboarding", { page });
        },
        page: pageParam,
        perPage,
        totalEntries,
      };

      loading = false;
    } catch (error) {
      referralLeads = [];
      loading = false;
    }
  };

  const referralLeadSentAt = referralLead => {
    if (referralLead.sent_at) {
      return referralLead.sent_at ? moment(referralLead.sent_at).fromNow() : "Today";
    } else {
      return referralLead.signed_up_at ? moment(referralLead.signed_up_at).fromNow() : "Today";
    }
  };

  const referralLeadStatus = referralLead => {
    const statusKey = {
      sent: "Sent",
      opened: "Delivered",
      signed_up: "Signed up",
      placed_first_order: "First order placed!",
    };
    return get(statusKey, referralLead.state, "Sending");
  };

  const emailBody = lead => {
    return encodeURIComponent(`Hi ${lead.user.first_name}! \n
    Friendly reminder to send your ${lead.retailer.order_day} order to me using Provi in 3 easy steps: \n
    Login at https://app.provi.com \n
    Click 'lists' in the top right corner \n
    Add products to your cart and submit your order. \n
    Provi is 100% free for you to use and is a great way to help keep us connected. Let me know if you have any questions. \n
    Cheers!
    `);
  };

  onMount(() => {
    fetchReferralLeads();
  });
</script>

<div class="fizz-container-medium fizz-surface fizz-margin-auto fizz-inset-square-24">
  <div class="fizz-stack-8">
    <h4 class="fizz-heading-4">Retailer Progress</h4>
  </div>

  <div class="fizz-flex-row fizz-text-subdued fizz-stack-16">
    <div class="fizz-flex-row-0 fizz-gap-64 fizz-flex-item">
      <p class="fizz-hide-on-small">Invite Sent</p>
      <p>Retailer</p>
    </div>

    <p>Invite Status</p>
  </div>

  <div>
    {#if !loading}
      {#each referralLeads as referralLead}
        <div class="fizz-bordered-squared fizz-flex-row fizz-inset-square-12 fizz-text-small">
          <div class="fizz-flex-row-0 fizz-gap-64 fizz-flex-item">
            <p class="fizz-hide-on-small">{referralLeadSentAt(referralLead)}</p>
            <div class="fizz-flex-vertical">
              <p>{referralLead.retailer.name}</p>
              <p class="fizz-text-subdued"
                >{referralLead.user.first_name} {referralLead.user.last_name}</p
              >
              <p class="fizz-text-subdued"
                >{referralLead.user.email}
                {referralLead.user.phone ? `, ${referralLead.user.phone}` : ""}</p
              >
            </div>
          </div>

          <div class="fizz-flex-vertical">
            <p>{referralLeadStatus(referralLead)}</p>
            <a
              class="fizz-text-brandSecondary underline-hover"
              href="mailto:{referralLead.user.email ||
                'FILL EMAIL HERE'}?subject=Have you signed up for Provi yet?&body={emailBody(
                referralLead,
              )}">Email Reminder</a
            >
          </div>
        </div>
      {:else}
        <div class="fizz-inset-square-12 fizz-flex-row fizz-justify-center">
          <p>No Invitations Sent</p>
        </div>
      {/each}
    {/if}

    {#if referralLeads?.length}
      <div class="fizz-flex-row fizz-justify-end">
        <PaginationSmall bind:pagination />
      </div>
    {/if}
  </div>
</div>
